/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#014160" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="">
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname" v-if="menu.flagList.length != menu.menus.length">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" v-show="resCodeList.indexOf(chmenu.resCode) != -1" :index="'/'+chmenu.url" :key="chmenu.menuid">
          <i :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: [],
      resCodeList: JSON.parse(localStorage.getItem('userdata')).resCodeList
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    console.log('resCodeList', this.resCodeList);
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: 'li-icon-xiangmuguanli',
          menuname: '培训管理',
          hasThird: null,
          url: null,
          flagList:[],
          menus: [
            {
              menuid: 2,
              icon: 'el-icon-date',
              menuname: '班级管理',
              hasThird: 'N',
              url: 'goods/classInfo',
              menus: null,
              resCode: 'RES0001'
            },
            {
              menuid: 23,
              icon: 'el-icon-s-data',
              menuname: '班级列表',
              hasThird: 'N',
              url: 'goods/classInfoByBzr',
              menus: null,
              resCode: 'RES0018'
            },
            {
              menuid: 75,
              icon: 'el-icon-user',
              menuname: '学员管理',
              hasThird: 'N',
              url: 'system/student',
              menus: null,
              resCode: 'RES0003'
            },
            {
              menuid: 35,
              icon: 'el-icon-s-operation',
              menuname: '课程表管理',
              hasThird: 'N',
              url: 'goods/courseTableManage',
              menus: null,
              resCode: 'RES0014'
            },
            {
              menuid: 36,
              icon: 'el-icon-discount',
              menuname: '学习卡管理',
              hasThird: 'N',
              url: 'goods/learningCardManage',
              menus: null,
              resCode: 'RES0015'
            },
            /*{
              menuid: 4,
              icon: 'el-icon-user',
              menuname: '学员管理',
              hasThird: 'N',
              url: 'goods/student',
              menus: null,
              resCode: 'RES0002'
            }*/
          ]
        },/*
        {
          menuid: 66,
          icon: 'li-icon-jichuguanli',
          menuname: '线下课程管理',
          hasThird: null,
          url: null,
          menus: [

          ]
        },*/
        {
          menuid: 33,
          icon: 'li-icon-dingdanguanli',
          menuname: '统计分析',
          hasThird: null,
          url: null,
          flagList:[],
          menus: [
            {
              menuid: 34,
              icon: 'el-icon-s-data',
              menuname: '统计分析',
              hasThird: 'N',
              url: 'report/reportChart',
              menus: null,
              resCode: 'RES0004'
            },
          ]
        },
        {
          menuid: 71,
          icon: 'li-icon-xitongguanli',
          menuname: '系统管理',
          hasThird: null,
          url: null,
          flagList:[],
          menus: [
            {
              menuid: 72,
              icon: 'el-icon-mobile-phone',
              menuname: '用户管理',
              hasThird: 'N',
              url: 'system/user',
              menus: null,
              resCode: 'RES0005'
            },
            {
              menuid: 73,
              icon: 'el-icon-s-custom',
              menuname: '角色管理',
              hasThird: 'N',
              url: 'system/Role',
              menus: null,
              resCode: 'RES0008'
            },
            {
              menuid: 3,
              icon: 'el-icon-s-data',
              menuname: '科目管理',
              hasThird: 'N',
              url: 'goods/subjectTree',
              menus: null,
              resCode: 'RES0006'
            },
            {
              menuid: 74,
              icon: 'el-icon-s-shop',
              menuname: '营销渠道',
              hasThird: 'N',
              url: 'system/marketing',
              menus: null,
              resCode: 'RES0007'
            },
            {
              menuid: 76,
              icon: 'el-icon-reading',
              menuname: '学习平台',
              hasThird: 'N',
              url: 'system/learnPlat',
              menus: null,
              resCode: 'RES0009'
            },
            {
              menuid: 78,
              icon: 'el-icon-school',
              menuname: '教室管理',
              hasThird: 'N',
              url: 'system/classroom',
              menus: null,
              resCode: 'RES0011'
            },
            {
              menuid: 79,
              icon: 'el-icon-s-management',
              menuname: '课程库管理',
              hasThird: 'N',
              url: 'course/courseManage',
              menus: null,
              resCode: 'RES0012'
            },
            {
              menuid: 80,
              icon: 'el-icon-menu',
              menuname: '课程表模板管理',
              hasThird: 'N',
              url: 'system/templateManage',
              menus: null,
              resCode: 'RES0013'
            },
            {
              menuid: 81,
              icon: 'el-icon-setting',
              menuname: '系统设置',
              hasThird: 'N',
              url: 'system/sysSetting',
              menus: null,
              resCode: 'RES0017'
            },
            /*{
              menuid: 77,
              icon: 'el-icon-reading',
              menuname: '机构管理',
              hasThird: 'N',
              url: 'system/orgManage',
              menus: null,
              resCode: 'RES0010'
            }*/
          ]
        }
      ],
      msg: 'success'
    }

    this.allmenu = res.data

    this.allmenu.forEach(x => {
      x.menus.forEach(y => {
        if (this.resCodeList != null && this.resCodeList.length > 0) {
          if (this.resCodeList.indexOf(y.resCode) == -1) {
            x.flagList.push(y.resCode);
          }
        }
      })
    })

    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue